export const Bio = {
  name: 'Zeyu Cui',
  roles: ['Full Stack Developer', 'Web Developer', 'Programmer'],
  description:
    'I’m a recent Master’s graduate in Information Technology from UTS, specializing in the MERN stack. Passionate about technology and lifelong learning, I’m eager to contribute as a Web Developer or Software Engineer. My skills in React, Node.js, and building innovative web solutions drive me to deliver impactful outcomes in the tech industry.',
  github: 'https://github.com/zeyucui1',
  resume:
    'https://drive.google.com/file/d/1GMwQkXLq0OFFdtW6hdTMvz04xXwAY5Qx/view?usp=sharing',
  linkedin: 'https://www.linkedin.com/in/zeyucui/',
  facebook: 'https://www.facebook.com/zeyu.cui.946',
}

export const skills = [
  {
    title: 'Frontend',
    skills: [
      {
        name: 'React Js',
        image:
          'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K',
      },
      {
        name: 'Redux',
        image:
          'https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg',
      },
      {
        name: 'Next Js',
        image:
          'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=',
      },
      {
        name: 'HTML',
        image: 'https://www.w3.org/html/logo/badge/html5-badge-h-solo.png',
      },
      {
        name: 'CSS',
        image:
          'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png',
      },
      {
        name: 'JavaScript',
        image:
          'https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png',
      },
      {
        name: 'sass',
        image:
          'https://upload.wikimedia.org/wikipedia/commons/thumb/9/96/Sass_Logo_Color.svg/2560px-Sass_Logo_Color.svg.png',
      },
      {
        name: 'AntDesign',
        image:
          'https://static-00.iconduck.com/assets.00/ant-design-icon-2048x2046-dl3neb73.png',
      },
      {
        name: 'Tailwind CSS',
        image:
          'https://res.cloudinary.com/startup-grind/image/upload/c_fill,dpr_2.0,f_auto,g_center,h_1080,q_100,w_1080/v1/gcs/platform-data-dsc/events/Tailwind_CSS_Logo.svg_GkNDLAs.png',
      },
      {
        name: 'Bootstrap',
        image:
          'https://img.icons8.com/?size=100&id=EzPCiQUqWWEa&format=png&color=000000',
      },
    ],
  },
  {
    title: 'Backend',
    skills: [
      {
        name: 'Node Js',
        image: 'https://nodejs.org/static/images/logo.svg',
      },
      {
        name: 'Express Js',
        image: 'https://icon.icepanel.io/Technology/svg/Express.svg',
      },

      {
        name: 'MySQL',
        image:
          'https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg',
      },
      {
        name: 'Postgresql',
        image: 'https://www.postgresql.org/media/img/about/press/elephant.png',
      },
      {
        name: 'MongoDB',
        image:
          'https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg',
      },
      {
        name: 'Supabase',
        image:
          'https://seeklogo.com/images/S/supabase-logo-DCC676FFE2-seeklogo.com.png',
      },
      {
        name: 'PHP',
        image: 'https://icon.icepanel.io/Technology/svg/PHP.svg',
      },
      {
        name: 'AWS',
        image: 'https://icon.icepanel.io/Technology/svg/AWS.svg',
      },
      {
        name: '.Net Core',
        image: 'https://icon.icepanel.io/Technology/svg/.NET-core.svg',
      },
    ],
  },
  {
    title: 'Mobile',
    skills: [
      {
        name: 'XML',
        image:
          'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBMw6_RdwKQ9bDFfnKDX1iwMl4bVJEvd9PP53XuIw&s',
      },
      {
        name: 'Swift',
        image: 'https://icon.icepanel.io/Technology/svg/Swift.svg',
      },
    ],
  },
  {
    title: 'Others',
    skills: [
      {
        name: 'Git',
        image: 'https://icon.icepanel.io/Technology/svg/Git.svg',
      },
      {
        name: 'GitHub',
        image:
          'https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png',
      },
      {
        name: 'Vercel',
        image:
          'https://w7.pngwing.com/pngs/436/888/png-transparent-vercel-hd-logo.png',
      },
      {
        name: 'VS Code',
        image:
          'https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519',
      },
      {
        name: 'Postman',
        image: 'https://icon.icepanel.io/Technology/svg/Postman.svg',
      },
      {
        name: 'Photoshop',
        image:
          'https://upload.wikimedia.org/wikipedia/commons/thumb/a/af/Adobe_Photoshop_CC_icon.svg/2101px-Adobe_Photoshop_CC_icon.svg.png',
      },
      {
        name: 'Figma',
        image: 'https://icon.icepanel.io/Technology/svg/Figma.svg',
      },
      {
        name: 'Labrika',
        image:
          'https://appsumo2-cdn.appsumo.com/media/users/avatars/logo_color300.png',
      },
    ],
  },
]

export const experiences = [
  {
    id: 0,
    img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTvRLwfs76_tc7JKuTYDu65fdB6mlLNcaDWyQ&s',
    role: 'Web developer Intern',
    company: 'Evaheld UTS startup, Ultimo,Sydney',
    date: 'April 2024 - July 2024',
    desc: [
      'Worked as a Web Developer Intern at Evaheld in Ultimo, Sydney from April 2024 to July 2024. Built advanced care plan section and partnership page using React, Next.js, and TailwindCSS. Refactored legacy forms with React Hook Form, ensuring data integrity with TypeScript and Zod. Implemented a 10-chapter advanced care plan form with pagination and PDF export. Improved site traffic by 120% by resolving SEO issues and optimizing content. Enhanced mobile performance, reducing page load times by 15%. Collaborated in an Agile team, managing tasks with Nifty and participating in daily stand-ups.',
    ],
    skills: [
      'ReactJS',
      'NextJS',
      'TypeScript',
      'Tailwind CSS',
      'MongoDB',
      'Figma',
      'SEO Optimization',
      'Speed Optimization',
      'Git',
      'Agile',
      'Responsive Web Design',
      'Nifty',
    ],
    doc: [
      'https://github.com/zeyucui1/image-storage/blob/main/Evaheld/acp.png?raw=true',
      'https://github.com/zeyucui1/image-storage/blob/main/Evaheld/partnership.png?raw=true',
      'https://github.com/zeyucui1/image-storage/blob/main/Evaheld/seo_optimization.png?raw=true',
      'https://github.com/zeyucui1/image-storage/blob/main/Evaheld/signature.png?raw=true',
      'https://github.com/zeyucui1/image-storage/blob/main/Evaheld/written_content_optimization.png?raw=true',
      'https://github.com/zeyucui1/image-storage/blob/main/Evaheld/logo.png?raw=true',
    ],
  },
  {
    id: 1,
    img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRckTSTrpZM-J0EGBu_MvdLJdv9fFOqDIIlnw&usqp=CAU',
    role: 'Front End Developer (School volunteer)',
    company: 'University of Tasmania, Australia',
    date: 'Feb 2023 - Nov 2023',
    desc: [
      'Led the creation of a AI Preprocess Data page & Homepage, leveraging the Ant Design UI Framework and React.JS to facilitate dynamic data display and user interaction. My responsibilities extended to database design, where I crafted the Entity-Relationship Diagram (ERD) and brought it to life using MySQL, ensuring robust data management. I also employed Figma for intuitive UI/UX designs and Styled-Components to guarantee web page responsiveness on various devices. Utilized React-Query to fetch and render backend data, adding interactive features such as chart data display and manipulation, reducing data processing time by 30%. Prepared user manual and interface design documentation, creating detailed user stories to explain the usage of each button, the purpose of each section, and overall navigation of the site, improving developer onboarding time by 25%. Collaborated with the ICT team using Trello in an Agile development environment, managing tasks, prioritizing backlog, and ensuring timely feature delivery. Orchestrated weekly discussions with the front-end team to delineate tasks and played a pivotal role in troubleshooting, all to refine front-end functionality and elevate the user experience.',
    ],
    skills: [
      'ReactJS',
      'React Query',
      'Ant Design UI Framework',
      'MySQL',
      'Figma',
      'Tailwind CSS',
      'JavaScript',
      'Git',
      'Database Design',
      'Responsive Web Design',
      'Trello',
    ],
    doc: [
      'https://github.com/zeyucui1/image-storage/blob/main/Qatar/home.png?raw=true',
      'https://github.com/zeyucui1/image-storage/blob/main/Qatar/AI_Training.png?raw=true',
      'https://github.com/zeyucui1/image-storage/blob/main/Qatar/Database.png?raw=true',
      'https://github.com/zeyucui1/image-storage/blob/main/Qatar/user_manual.png?raw=true',
    ],
  },
]

export const education = [
  {
    id: 0,
    img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTNL0v1T3PaZPJewp2-fCSSB8wXF3N-Pq4vRsp8wuA2&s',
    school: 'University of Technology Sydney, AU',
    date: ' Feb 2022 - Nov 2024',
    grade: '6.56 / 7 GPA',
    desc: "Receng graduated with high distinction (WAM 85.1/100, GPA 6.56/7) in a Master’s in Information Technology from the University of Technology, Sydney. I have developed a solid foundation through coursework in frontend development, software engineering fundamentals, database design, computer networks, UX/UI design, .NET fundamentals, iOS development, and system design and project management, showcasing both strong academic performance and practical expertise.",
    degree:
      'Master of Information Technology - MIT, Software Development Major',
  },
  {
    id: 1,
    img: 'data:image/png;base64,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',
    school: 'Australian Maritime College, AU',
    date: 'Feb 2017 - Dec 2020',
    grade: null,
    desc: 'I completed my Four years Engineering study at Australian Maritime College School, AU, where I have developed my problem-solving, creative thinking, systems thinking, analytical, teamwork, project management, adaptability, and ethical thinking skills.',
    degree: 'BE, Marine & Offshore Engineering',
  },
]

export const projects = [
  {
    id: 1,
    title: 'the-wild-oasis-hotel',
    date: 'Sep 2023 - Oct 2023',
    description:
      'The Wild Oasis Hotel Management Application revolutionizes hotel operations with its intuitive design for managing sales, cabins, bookings, and user data, all in one place. Seamlessly blending advanced JavaScript and ReactJS, it offers a user-friendly platform for hotel staff to enhance efficiency and customer service. Demo Access: Admin Email: zeyu@example.com, Password: 11111111. Perfect for managing daily hotel tasks and improving overall hospitality experiences.',
    image:
      'https://github.com/zeyucui1/image-storage/blob/main/project/the-wild-oasis.png?raw=true',
    tags: [
      'React',
      'Supabase',
      'react-query',
      'react-router-dom',
      'recharts',
      'styled-components',
      'react-hook-form',
    ],
    category: 'full stack',
    github: 'https://github.com/zeyucui1/the-wild-oasis',
    webapp: 'https://the-wild-oasis-hotel-eta.vercel.app',
  },
  {
    id: 2,
    title: 'zeyu-portfolio',
    date: 'Sep 2023 - Current',
    description:
      'My personal portfolio website serves as a digital gateway to my professional journey as a web developer. It is a carefully curated space where I have amalgamated my skills, projects, and experiences, providing a holistic view of my capabilities in web development. Crafted with a keen eye for design and functionality, this website not only showcases my technical proficiency but also my journey and growth in the ever-evolving landscape of web technologies.',
    image:
      'https://github.com/zeyucui1/image-storage/blob/main/project/portfolio.png?raw=true',
    tags: [
      'React',
      'HTML5',
      'CSS3',
      'JavaScript',
      'React Router',
      'Styled Components',
      'Git',
      'GitHub',
      'Material UI',
      'Framer Motion',
    ],
    category: 'react app',
    github: 'https://github.com/zeyucui1/zeyu-portfolio',
    webapp: 'https://zeyu-portfolio.vercel.app',
  },
  {
    id: 3,
    title: 'PizzaHouse',
    date: 'Aug 2023 - Sep 2023',
    description:
      'PizzaHouse is a React-based practice project designed to simulate the entire process of ordering pizza online. As an exercise focused on honing skills in state management with Redux and responsive design with Tailwind CSS, this application encompasses essential features needed for a functional pizza ordering system.',
    image:
      'https://github.com/zeyucui1/image-storage/blob/main/project/pizza_house.png?raw=true',
    tags: ['React', 'Redux', 'Tailwind CSS', 'HTML5', 'CSS3', 'React Router'],
    category: 'react app',
    github: 'https://github.com/zeyucui1/pizza-house',
    webapp: 'https://pizza-house-ochre.vercel.app',
  },
  {
    id: 4,
    title: 'WorldWise',
    date: 'Aug 2023 - Sep 2023',
    description:
      "WorldWise is a user-friendly travel tracking application designed for wanderlust enthusiasts. This application offers a way to catalog your travels by saving the places you've visited and the places you dream to explore. It combines sleek design with practical functionality, including notes addition, a visual map of your travels, and more!",
    image:
      'https://github.com/zeyucui1/image-storage/blob/main/project/worldwise.png?raw=true',
    tags: ['React', 'React Router', 'React Leaflet', 'CSS Modules'],
    category: 'react app',
    github: 'https://github.com/zeyucui1/worldwise',
    webapp: 'https://worldwise-amber-eight.vercel.app',
  },

  {
    id: 5,
    title: 'e-commerce-proshop',
    date: 'April 2024 - June 2024',
    description:
      'E-commerce Proshop is a comprehensive e-commerce MERN STACK application designed to sell electronics. Inspired by websites like JB-Hifi, it showcases various products, offering features such as secure account creation, order tracking, and product reviews. It also includes admin functionalities for product management and user control. Demo Access: User Email: test@email.com, Password: 123456; Admin Email: admin@email.com, Password: 123456. The project aims to deliver a seamless shopping experience with modern web technologies.',
    image:
      'https://github.com/zeyucui1/image-storage/blob/main/project/proshop.png?raw=true',
    tags: [
      'React',
      'Redux',
      'Node.js',
      'Express',
      'MongoDB',
      'JWT',
      'PayPal API',
      'Bootstrap',
    ],
    category: 'full stack',
    github: 'https://github.com/zeyucui1/proshop',
    webapp: 'https://proshop-bu4u.onrender.com',
  },
  {
    id: 6,
    title: 'Easy Rent',
    date: 'April 2024 - May 2024',
    description:
      'Easy Rent is a school assignment project that provides a streamlined online car renting experience for potential users. This dynamic website features rich interactive functionalities such as browsing cars by type or brand, searching cars using keywords, checking availability, making rental requests, and confirming or canceling orders. Utilizing AJAX and JSON for data handling and built with HTML, CSS, JavaScript, and PHP, this project demonstrates the ability to manage user sessions, store data in JSON files, and interact with MySQL databases. Perfect for learning practical website design and development techniques.',
    image:
      'https://github.com/zeyucui1/image-storage/blob/main/project/easyrent_home.png?raw=true',
    tags: ['HTML', 'CSS', 'JavaScript', 'AJAX', 'JSON', 'PHP', 'MySQL'],
    category: 'full stack',
    github: 'https://github.com/zeyucui1/easyRent',
    webapp: '',
  },
]

// export const TimeLineData = [
//   { year: 2017, text: 'Started my journey' },

// ]
